import React, { useMemo } from 'react'

import {
  CheckboxInputStyle,
  UncontrolledRadioInput,
} from '@src/components/Inputs'
import {
  OptionContentLabels,
  OptionContentText,
  OptionLabel,
  PopoverOptionContainer,
} from '@src/components/BottomSheet/BottomSheet.styles'
import {
  OutletFulfilmentStateType,
  useOutletFulfilment,
} from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/useOutletFulfilment'
import { CurrentFulfilmentType } from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/validation'
import { useTablesQuery } from '@src/hooks/sharedQueries/useTables/useTables'

import { createTableOptions } from '@src/utils/createTableOptions'
import { LoadingSpinner } from '../Loaders/LoadingSpinner'

export const TableSection: React.FC = () => {
  const outletFulfilment = useOutletFulfilment({
    stateType: OutletFulfilmentStateType.LOCAL,
  })

  const selectedTableId = outletFulfilment.data.historicalData.tableId

  const { data, loading, error } = useTablesQuery({
    outletId: outletFulfilment.outlet.id,
  })

  const tableOptions = useMemo(
    () => (data && data.tables ? createTableOptions(data.tables) : []),

    [data && data.tables]
  )

  // TODO: Skeleton loading
  if (loading) {
    return <LoadingSpinner />
  }

  // TODO: Nice error
  if (error || !data) {
    // eslint-disable-next-line no-console
    console.error(error)
    return <span>{'An unexpected error occurred'}</span>
  }

  return (
    <>
      {tableOptions.map((table, index) => (
        <PopoverOptionContainer key={table.value}>
          <UncontrolledRadioInput
            label={
              <>
                <OptionLabel>
                  <OptionContentLabels>
                    <OptionContentText>{table.name}</OptionContentText>
                  </OptionContentLabels>
                </OptionLabel>
              </>
            }
            style={CheckboxInputStyle.TICK}
            checked={selectedTableId === table.value}
            onClick={() => {
              outletFulfilment.setCurrentFulfilment({
                type: CurrentFulfilmentType.TABLE,
                tableId: table.value,
              })
            }}
            dataTestId={`service-wherepopover-radio-table${index}`}
          />
        </PopoverOptionContainer>
      ))}
    </>
  )
}
